/**
 * 判断h5页面是否在某个小程序环境中
 */

/**
 * @name 判断是否在钉钉小程序中
 * 钉钉小程序的ua 同时包含 'dingtalk'和（'dd-web'||'miniprogram'）
 */

export var isDingEnv = navigator.userAgent.toLowerCase().indexOf('dingtalk') > -1 && (navigator.userAgent.toLowerCase().indexOf('dd-web') > -1 || navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1);

/** 
 * 判断是否是支付宝小程序
 */
export var isZFBEnv = navigator.userAgent.indexOf('AliApp') > -1;

/**
 * @name 判断是否在微信小程序中
 *
 * */
export var isWxEnv = window.__wxjs_environment === 'miniprogram' ||
// 不在钉钉小程序内并且ua包含 miniprogram
!isDingEnv && !isZFBEnv && navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1;